import { render, staticRenderFns } from "./MonthlyPurchaseTable.vue?vue&type=template&id=a4f0f5ee&"
import script from "./MonthlyPurchaseTable.vue?vue&type=script&lang=js&"
export * from "./MonthlyPurchaseTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VDataTable,VLayout})
